import { render } from "./footerx.vue?vue&type=template&id=6ed5dfda&scoped=true"
import script from "./footerx.vue?vue&type=script&lang=js"
export * from "./footerx.vue?vue&type=script&lang=js"

import "./footerx.vue?vue&type=style&index=0&id=6ed5dfda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5dfda"]])

export default __exports__